import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants, EventId } from '@ps/isp-web-services-types';
import type {
  DartsFixture,
  DartsFixtureSetsScore,
  DartsScore
} from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

import ScoreboardWrapper from '../ScoreboardWrapper/ScoreboardWrapper';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventTime: string;
  dartsFixture?: DartsFixture;
}

const isLegsAndSets = (
  fixture?: DartsFixture
): fixture is DartsFixture & { score?: DartsFixtureSetsScore } => fixture?.type === 'SETS';

const isLegsOnly = (fixture?: DartsFixture): fixture is DartsFixture & { score?: DartsScore } =>
  fixture?.type === 'LEGS';

const getLegsAndSetsScores = (fixture?: DartsFixture) =>
  isLegsAndSets(fixture) ? fixture.score : null;

const getLegsOnlyScores = (fixture?: DartsFixture) => (isLegsOnly(fixture) ? fixture.score : null);

const Darts: React.FC<Props> = ({ enrichedParticipants, dartsFixture, eventId, eventTime }) => {
  const [participantHome, participantAway] = enrichedParticipants ?? [];

  const { setsWon, currentSet } = getLegsAndSetsScores(dartsFixture) ?? {};
  const currentScores = isLegsAndSets(dartsFixture)
    ? currentSet?.score
    : getLegsOnlyScores(dartsFixture);

  return (
    <ScoreboardWrapper eventId={eventId} eventTime={eventTime} eventTypeId={EventTypeId.E_SPORTS}>
      <Scoreboard>
        <ScoreboardParticipants>
          <ScoreboardParticipant name={participantHome.participant} />
          <ScoreboardParticipant name={participantAway.participant} />
        </ScoreboardParticipants>
        <ScoreboardScores>
          {isLegsAndSets(dartsFixture) && (
            <ScoreboardScore
              score={[setsWon?.home ?? null, setsWon?.away ?? null]}
              scoreCharacterLength={getScoreCharacterLength(EventTypeId.DARTS, [
                setsWon?.home ?? 0,
                setsWon?.away ?? 0
              ])}
            />
          )}
          <ScoreboardScore
            score={[currentScores?.home ?? null, currentScores?.away ?? null]}
            scoreCharacterLength={getScoreCharacterLength(EventTypeId.DARTS, [
              currentScores?.home ?? 0,
              currentScores?.away ?? 0
            ])}
          />
        </ScoreboardScores>
      </Scoreboard>
    </ScoreboardWrapper>
  );
};

export default Darts;
